// extracted by mini-css-extract-plugin
module.exports = {"link-like-paragraph":"_2qDw7E"};